import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Header, Button, Grid } from "semantic-ui-react";
import { ReactSVG } from "react-svg";
import { OfficeViewModel } from '../../types/OfficeDTO';
import DataGrid, { Column } from '../Common/SharedComponents/DataGrid';
import { DynamicSearchResponse, FilterData } from '../../types/filterDataGridDTO';
import DocumentAdd from "../../assets/images/document-add.svg";
import UserInfo from '../Common/SharedComponents/UserInfo';
import AdminSidebar from '../Common/SharedComponents/AdminSidebar';
import AppContext, { token_config } from '../../AppContext';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';

const Offices: React.FC = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(AppContext);

  useEffect(() => {
    if (userInfo !== undefined) {
      const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];
      if (!privileges.includes(token_config.MANAGE_OFFICES)) {
        navigate('/');
      }
    }
  }, [userInfo, navigate]);

  const [responseDataModel, setResponseDataModel] = useState<DynamicSearchResponse<OfficeViewModel> | null>(null);
  const [filters, setFilters] = useState<Record<string, FilterData> | null>(null);

  const columns: Column<OfficeViewModel>[] = [
    { field: 'officeDisplayName', header: "Office", sortable: true, headerStyle: { textAlign: 'left', paddingLeft: 10, width: '50%' }, style: { textAlign: 'left', fontSize: '16px' }, accessor: (row: OfficeViewModel) => row.officeDisplayName ? <Link to={`/office/${row.officeId}`}>{row.officeDisplayName}</Link> : null },
    { field: 'isActive', header: 'Status', sortable: true, className: "wrap-text", headerStyle: { textAlign: 'center', width: '30%' }, accessor: (row: OfficeViewModel) => row.isActive ? 'Yes' : 'No' },
  ];

  useEffect(() => {
    document.title = 'Office - Adjure';
  }, []);

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">Office</Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <Button color="violet" onClick={() => navigate('/office')}>
            <Button.Content visible style={{ whiteSpace: 'nowrap' }}>
              Add Office
            </Button.Content>
            <Button.Content visible>
              <ReactSVG src={DocumentAdd} />
            </Button.Content>
          </Button>
          <SwitchTheme />
        </div>
      </div>
      <div className="section__body">
        <Grid padded>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={3} computer={3}>
              <AdminSidebar />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={13} computer={13}>
              <DataGrid<OfficeViewModel>
                apiUrl={`/AdminSetting/OfficeDataGrid`}
                initialViewModelURL={`/AdminSetting/GetOfficeDataGrid`}
                columns={columns}
                rowsPerPage={10}
                defaultSortByField={'officeDisplayName'}
                defaultSortOrderDesc={false}
                rowKey={(row: OfficeViewModel) => row.officeId}
                noDataMessage={'No office(s) to display'}
                searchPlaceholder='Search by office'
                filters={filters}
                setFilters={setFilters}
                responseDataModel={responseDataModel}
                setResponseDataModel={setResponseDataModel}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </section>
  );
}

export default Offices;